"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var FullStory = __importStar(require("@fullstory/browser"));
var react_1 = require("react");
var useLayoutLinks_1 = require("./useLayoutLinks");
var PRISM_PENDO_SCRIPT = 'prism-pendo-script';
var pendoScript = function () { return "\n(function(apiKey){\n(function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];\nv=['initialize','identify','updateOptions','pageLoad'];for(w=0,x=v.length;w<x;++w)(function(m){\no[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);\ny=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';\nz=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');\n})('55acdea7-9864-4dca-57b5-bef70c5fc999');\n"; };
var createScript = function (id, body) {
    var script = document.createElement('script');
    script.id = id;
    script.innerText = body;
    return script;
};
var hasLink = function (key) { return function (link) { return link.id === key; }; };
var useAnalytics = function (_a) {
    var currentIdentity = _a.currentIdentity, fullStoryOrg = _a.fullStoryOrg, links = _a.links, bank = _a.bank;
    (0, react_1.useEffect)(function () {
        var shouldAddScripts = !document.getElementById(PRISM_PENDO_SCRIPT);
        if (shouldAddScripts) {
            document.head.appendChild(createScript(PRISM_PENDO_SCRIPT, pendoScript()));
            FullStory.init({
                orgId: fullStoryOrg,
            });
        }
    }, [fullStoryOrg]);
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        if (currentIdentity) {
            FullStory.identify(currentIdentity.identityUuid, {
                soldToParty_str: (_a = currentIdentity.customer) === null || _a === void 0 ? void 0 : _a.stpNumber,
                systemUserId_str: currentIdentity.uniqueId,
                customerCoreUuid_str: (_b = currentIdentity.customer) === null || _b === void 0 ? void 0 : _b.customerUuid,
                displayName: currentIdentity.identityUuid,
                identityCoreUuid_str: currentIdentity.identityUuid,
                isManager: currentIdentity.isManager,
            });
            pendo.initialize({
                account: {
                    id: (_c = currentIdentity.customer) === null || _c === void 0 ? void 0 : _c.customerUuid,
                },
                visitor: {
                    id: currentIdentity.identityUuid,
                },
            });
        }
    }, [currentIdentity]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (currentIdentity && bank && ((_a = links === null || links === void 0 ? void 0 : links.primaryLinks) === null || _a === void 0 ? void 0 : _a.length)) {
            pendo.updateOptions({
                visitor: {
                    id: currentIdentity.identityUuid,
                    isAdmin: (_b = links.secondaryLinks) === null || _b === void 0 ? void 0 : _b.some(hasLink(useLayoutLinks_1.SecondaryLinks.Admin)),
                    isManager: currentIdentity.isManager,
                    hasInitiatives: links.primaryLinks.some(hasLink(useLayoutLinks_1.PrimaryLinks.Initiatives)),
                    hasOneToOnes: links.primaryLinks.some(hasLink(useLayoutLinks_1.PrimaryLinks.Initiatives)),
                    hasBank: !!bank,
                },
            });
        }
    }, [bank, currentIdentity, links]);
};
exports.default = useAnalytics;
//# sourceMappingURL=useAnalytics.js.map